import { useCallback } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import { imageToVideoAtom } from './state';
import { canGenerate } from '../utils/validators';

export const useImageToVideoState = () => useAtomValue(imageToVideoAtom);
export const useSetImageToVideoState = () => useSetAtom(imageToVideoAtom);

export const useStyle = () => {
  const state = useAtomValue(imageToVideoAtom);
  const setState = useSetAtom(imageToVideoAtom);

  const setStyle = useCallback(
    (updater: (prev: typeof state.style) => typeof state.style) =>
      setState((prev) => ({ ...prev, style: updater(prev.style) })),
    [setState]
  );

  return [state.style, setStyle] as const;
};

export const useRuntime = () => {
  const state = useAtomValue(imageToVideoAtom);
  const setState = useSetAtom(imageToVideoAtom);

  const setRuntime = useCallback(
    (updater: (prev: typeof state.runtime) => typeof state.runtime) =>
      setState((prev) => ({ ...prev, runtime: updater(prev.runtime) })),
    [setState]
  );

  return [state.runtime, setRuntime] as const;
};

export const useUi = () => {
  const state = useAtomValue(imageToVideoAtom);
  const setState = useSetAtom(imageToVideoAtom);

  const setUi = useCallback(
    (updater: (prev: typeof state.ui) => typeof state.ui) =>
      setState((prev) => ({ ...prev, ui: updater(prev.ui) })),
    [setState]
  );

  return [state.ui, setUi] as const;
};

export const useAdjustments = () => {
  const state = useAtomValue(imageToVideoAtom);
  const setState = useSetAtom(imageToVideoAtom);

  const setAdjustments = useCallback(
    (updater: (prev: typeof state.adjustments) => typeof state.adjustments) =>
      setState((prev) => ({ ...prev, adjustments: updater(prev.adjustments) })),
    [setState]
  );

  return [state.adjustments, setAdjustments] as const;
};

export const useCanGenerate = () => {
  const state = useAtomValue(imageToVideoAtom);
  return canGenerate(state);
};
